import React from 'react';
import {OnChangeValue} from "../../../../Intefaces";
import {useTranslation} from "react-i18next";
import {useGoogleLogin} from '@react-oauth/google';
import {CryptoUtil, CryptoUtilPrefix} from "../../../../../utils/crypto/CryptoUtil";
import {JoinType, MutationLoginWithSocialArgs} from "../../../../../graphql/types";

export const AuthLoginGoogle = (props: {
    onLoginWithGoogle: OnChangeValue<MutationLoginWithSocialArgs>
}) => {
    const [t] = useTranslation('common');

    const login = useGoogleLogin({
        onSuccess: async (tokenResponse) => {
            const res = await fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
                headers: {Authorization: `Bearer ${tokenResponse.access_token}`}
            });
            const userInfo = await res.json();
            const email = userInfo.email;
            const pw = CryptoUtil.encryptPw(CryptoUtilPrefix.Google, userInfo.sub);
            props.onLoginWithGoogle({email, pw, joinType: JoinType.Google});
        },
        onError: (error) => {
            console.log(error);
        }
    });

    return (
        <>
            <button
                type='button'
                style={{width: '100%', marginBottom: 10}}
                className='btn btn-outline-secondary'
                onClick={() => login()}>
                {t('auth.btnGoogle')}
            </button>
        </>
    )
}
